import styles from './modal.module.scss'
import productList from '../utils/products'
import { useNavigate, useLocation } from 'react-router-dom'
import { useState } from 'react'
function Modal(props) {
    const navigate = useNavigate();
    const [isAc, setIsAc] = useState(0);
    const { code, onHideModal } = props;

    const handleAcInd = (ind) => {
        setIsAc(ind);
        navigate('/dashDetail/' + productList[ind].key);
    }

    const handleGoto = (key) => {
        navigate('/dashDetail/' + key);
    }
    return (
        <>
            <div className={
                styles.Modal
            } onMouseLeave={onHideModal}>
                <div className={
                    styles.Modal_content
                }>
                    <div className={styles.Modal_content_box}>
                        <div className={styles.Modal_content_box_name}>
                            {productList.map((it, ind) => <div className={isAc === ind ? styles.Modal_content_box_name_item_ac : styles.Modal_content_box_name_item} onClick={() => handleAcInd(ind)}>{it.title}</div>)}
                        </div>
                        <div className={styles.h1}></div>
                        <div className={styles.Modal_img}>
                            <img src={productList[isAc].img} onClick={() => handleGoto(productList[isAc].key)} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Modal;